import { useRef } from "react";
import { useInView } from "framer-motion";

export const Mark = ({ children, delay = 0.45, underline = false, margin = "-15% 0px" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin });
  return (
    <span
      ref={ref}
      className={`${underline ? "mark-lime-underline" : "mark-lime"}${inView ? " mark-on" : ""}`}
      style={{ "--mark-delay": `${delay}s` }}
    >
      {children}
    </span>
  );
};
